import { Loading } from 'src/shared/design-system/Loading';
import styled from 'styled-components';

const Container = styled.div`
  padding: 50px 0;
`;

export const Loader = () => (
  <Container style={{ padding: '50px 0' }}>
    <Loading delayMs={300} size={100} />
  </Container>
);
